import type { FaireProductEntity } from "../../entity_types/product";

export const p_3xv8e9q6ct: FaireProductEntity = {
  token: "p_3xv8e9q6ct",
  type: "product",
  name: "Moroccan Stemless Goblet - Amber",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/281b7fe956f26a1d3d65cea3050e4a1646192b874430958a22e2f96264178f5b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e398ebae9abbe12ada6ad5dd1097e178032bcc337232093e62265c0bd89779a5.jpeg",
    "https://cdn.faire.com/fastly/a9b6dd4568a28b9a808d890b9a3e84fa3e6643efd5d96b51264060613f2bd96e.jpeg",
    "https://cdn.faire.com/fastly/8d3225b41ec9c7d8f8a37af1c1f5c3282a63c52d60b8fdd55843e142169af02f.jpeg",
    "https://cdn.faire.com/fastly/a6db4a9fbbd6509edad31830efbc85885f9ccedb1c5212139fba2264cba2d1d8.jpeg",
    "https://cdn.faire.com/fastly/929c7696aa2e7b4790a50fe5fc97eb5a3983d49d8930ff9248bccae8a696fe5d.jpeg",
    "https://cdn.faire.com/fastly/55c1e2f00fd45203a080b70cb3d7f033b7e75c4838503665892130e0e0a40258.jpeg",
    "https://cdn.faire.com/fastly/dc3cbd15550d9e81be5a38ad473b572841818798f50c66fde9d4a621cc46abfc.jpeg",
    "https://cdn.faire.com/fastly/62ccfdb07098249610073842a1b1453402383370c9fe94446cfc6c39b08ca517.jpeg",
    "https://cdn.faire.com/fastly/a80fc71d5dc9ac6edcc090da0d4d82bf0e5c0a950e90f63ea00fd710f9bcd627.jpeg",
  ],
  priceDollars: 5.5,
  description:
    "**Packaged in sets of 4 - 16 single glasses in a case. Price shown is per glass.\n\nWhether you're sipping fine wine, enjoying a cocktail, or serving water at a special dinner, these Moroccan handblown glasses are versatile and complement any occasion.\n\nOur Moroccan glassware is made from recycled wine bottles, beer bottles, jars, or other glass containers. Slight variations in hue/color can arise due to variations in temperature, the amount of glass used, or even the artistic choices made during production. These differences contribute to the unique charm and individual character of each piece. \n\nOur skilled artisans meticulously handcraft each glass, ensuring the utmost precision and attention to detail. The result is a one-of-a-kind piece that boasts both quality and uniqueness.\n\nCare - Dishwasher safe, but please note: handblown glass is sensitive to drastic temperature changes.\n\nPackaged in sets of 4 in traditional Moroccan gift packaging.\n\n12 fl oz ",
  tags: [],
  msrpDollars: 11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:54:17.504Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
